import { createContext, useContext } from 'react';
import type { ProjectIconName } from '@shared/project-icon';

/** The project a card belongs to, where cards from several projects share a board (the master board, T-26). */
export interface TaskCardProject {
  name: string;
  /** Hex colour (T-18): the card's edge and its icon. */
  color: string;
  /** Its refs' prefix: SF-T-42 (T-25). */
  task_prefix: string;
  icon: ProjectIconName | null;
}

/**
 * Task id → its project. Provided by the master board; elsewhere every card is the current
 * project's, so there's none and cards look as they always have.
 */
export const TaskCardProjectContext = createContext<((taskId: string) => TaskCardProject | undefined) | null>(null);

export function useTaskCardProject(taskId: string): TaskCardProject | undefined {
  return useContext(TaskCardProjectContext)?.(taskId);
}
